import { createFileRoute } from '@tanstack/react-router'
import { AdminUsersPage } from '@/features/admin/users'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/users/')({
  component: AdminUsersPage,
  beforeLoad: requireRole(['admin']),
})
